module.exports = __webpack_public_path__ + "static/media/banner-janeiro-2025.93a7ee56.png";